import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import fallbackHero from '@/assets/fish-hero.webp';

const ROTATE_MS = 4000;
const FADE_MS = 1000;

export default function HomeHeroCarousel() {
  const [images, setImages] = useState<string[]>([fallbackHero]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let cancelled = false;
    supabase
      .from('site_settings')
      .select('value')
      .eq('key', 'home_hero_images')
      .maybeSingle()
      .then(({ data }) => {
        if (cancelled || !data?.value) return;
        try {
          const parsed = JSON.parse(data.value);
          if (Array.isArray(parsed) && parsed.length > 0) {
            setImages(parsed.filter((u): u is string => typeof u === 'string' && !!u));
          }
        } catch {
          /* ignore */
        }
      });
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (images.length <= 1) return;
    const t = setInterval(() => {
      setIndex((i) => (i + 1) % images.length);
    }, ROTATE_MS);
    return () => clearInterval(t);
  }, [images.length]);

  return (
    <div className="relative w-full h-[40vh] md:h-[55vh] overflow-hidden bg-muted">
      {images.map((src, i) => (
        <img
          key={`${src}-${i}`}
          src={src}
          alt=""
          role="presentation"
          fetchPriority={i === 0 ? 'high' : 'low'}
          decoding={i === 0 ? 'sync' : 'async'}
          loading={i === 0 ? 'eager' : 'lazy'}
          className="absolute inset-0 w-full h-full object-cover"
          style={{
            opacity: i === index ? 1 : 0,
            transition: `opacity ${FADE_MS}ms ease-in-out`,
          }}
        />
      ))}
    </div>
  );
}
